import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetDepositPromotionResponseData } from '@/modules/promotion/type'
import DepositPromotionTable from '../DepositPromotionTable'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import DepositPromotionPresetGallery from '@/modules/promotion/components/DepositPromotionPresetGallery'

interface DepositPromotionListingProps {
	data: GetDepositPromotionResponseData[]
	total: number
	isLoading?: boolean
}

export default function DepositPromotionListing({
	data,
	total,
	isLoading,
}: DepositPromotionListingProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_DEPOSIT_PROMOTION,
	)

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`รายการโปรโมชั่น`} description="รายการโปรโมชั่น" />
				{hasWritePermission && (
					<Button asChild variant="default">
						<Link to="/operator/deposit-promotion/create-promotion">
							เพิ่มโปรโมชั่น
						</Link>
					</Button>
				)}
			</div>
			<Separator />
			{hasWritePermission && <DepositPromotionPresetGallery />}
			<DepositPromotionTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
